import File from '@/models/File'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,

  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    fileDetails: null
  },

  mutations: {
    setFileList(state, files) {
      each(files, file => {
        const exist = find(state.list, { id: file.id })
        if (!exist) {
          state.list.push(new File(file))
        }
      })
    },

    clearFileList(state) {
      state.list = []
    },

    clearFileListMeta(state) {
      state.listMeta = {
        current_page: 0,
        last_page: 1
      }
    },

    setFileListMeta(state, meta) {
      state.listMeta = meta
    },

    setFileDetails(state, file) {
      if (file instanceof File) {
        state.fileDetails = file
      } else {
        state.fileDetails = new File(file)
      }
    },

    clearFileDetails(state) {
      state.fileDetails = null
    }
  },

  actions: {
    async getFiles({ commit }, params) {
      commit('clearFileList')
      commit('clearFileListMeta')

      const query = File.page(params.page || 1).where('userId', params.id)

      const res = await query.get()

      commit('setFileList', res.data)
      commit('setFileListMeta', res.meta)
    },

    async getFileDetails({ commit }, id) {
      const { data } = await Api.get(`file/${id}`)
      commit('setFileDetails', data.data)
    },

    async downloadFile({ commit, state }) {
      const file = await Api.get(`download-file/${state.fileDetails.id}`, {
        responseType: 'blob'
      })

      return file
    },

    async deleteFile({ commit, state }) {
      const file = await Api.delete(`file/${state.fileDetails.id}`)

      return file
    }
  }
}
